import { Formik } from 'formik';
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from '../../../../context/NotificationContext';
import { initValuesEvent, validationSchemaEvent } from './EventsFormValidator';
import CreateEventsForm from './CreateEventsForm';

const FormCreateEvent = ({ onClose, onSuccess, valuesToEdit }) => {
    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const isEditing = valuesToEdit && Object.keys(valuesToEdit).length > 0;
    const initialValues = isEditing ? { ...initValuesEvent, ...valuesToEdit } : initValuesEvent;

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const payload = {
                ...values,
                start_date: values.start_date?.toISOString ? values.start_date.toISOString() : values.start_date,
                end_date: values.end_date?.toISOString ? values.end_date.toISOString() : values.end_date,
            };

            if (isEditing) {
                await axios.put(`/app-events/${valuesToEdit._id}`, payload);
            } else {
                await axios.post('/app-events', payload);
            }

            showSnackbar({
                severity: 'success',
                title: 'Eventos',
                message: isEditing ? 'Evento actualizado exitosamente.' : 'Evento creado exitosamente.'
            });

            resetForm();
            if (onSuccess) onSuccess();
        } catch (error) {
            showSnackbar({
                severity: 'error',
                title: 'Eventos',
                message: 'Ha ocurrido un error al guardar el evento.'
            });
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchemaEvent}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            <CreateEventsForm onClose={onClose} />
        </Formik>
    );
};

export { FormCreateEvent };
export default FormCreateEvent;
